import React from 'react';

import { Information } from '@johnlewispartnership/wtr-ingredients/foundations/icons';

import styles from './SearchError.scss';

const NO_RESULTS_MESSAGE = 'No addresses found. Check your address or enter address manually.';
const ERROR_MESSAGE = 'Something went wrong. Try again later or enter address manually.';

interface SearchErrorProps {
  apiError: boolean;
}

const SearchError: React.FC<SearchErrorProps> = ({ apiError }) =>
  apiError ? (
    <div data-test="address-error" className={styles.searchItemError}>
      {ERROR_MESSAGE}
      <Information className={styles.icon} />
    </div>
  ) : (
    <div data-test="address-no-results" className={styles.searchItemNoResult}>
      {NO_RESULTS_MESSAGE}
    </div>
  );

export default SearchError;
